import { render, staticRenderFns } from "./ResortCom.vue?vue&type=template&id=578f74fe&scoped=true"
import script from "./ResortCom.vue?vue&type=script&lang=js"
export * from "./ResortCom.vue?vue&type=script&lang=js"
import style0 from "./ResortCom.vue?vue&type=style&index=0&id=578f74fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f74fe",
  null
  
)

export default component.exports